/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HoldsChallengeBatchRequest
 */
export interface HoldsChallengeBatchRequest {
    /**
     * Array of hold IDs to challenge
     * @type {Array<string>}
     * @memberof HoldsChallengeBatchRequest
     */
    holdIds: Array<string>;
    /**
     * Hours to respond to challenge (24 for MVP)
     * @type {number}
     * @memberof HoldsChallengeBatchRequest
     */
    responseHours?: number;
}

/**
 * Check if a given object implements the HoldsChallengeBatchRequest interface.
 */
export function instanceOfHoldsChallengeBatchRequest(value: object): value is HoldsChallengeBatchRequest {
    if (!('holdIds' in value) || value['holdIds'] === undefined) return false;
    return true;
}

export function HoldsChallengeBatchRequestFromJSON(json: any): HoldsChallengeBatchRequest {
    return HoldsChallengeBatchRequestFromJSONTyped(json, false);
}

export function HoldsChallengeBatchRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): HoldsChallengeBatchRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'holdIds': json['hold_ids'],
        'responseHours': json['response_hours'] == null ? undefined : json['response_hours'],
    };
}

  export function HoldsChallengeBatchRequestToJSON(json: any): HoldsChallengeBatchRequest {
      return HoldsChallengeBatchRequestToJSONTyped(json, false);
  }

  export function HoldsChallengeBatchRequestToJSONTyped(value?: HoldsChallengeBatchRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hold_ids': value['holdIds'],
        'response_hours': value['responseHours'],
    };
}

